module.exports = __webpack_public_path__ + "img/sent_small_white.9f8386cf.svg";